<div class="tooltip-surface" [innerHTML]="html"></div>
